var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCincinnatiRedsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 176 120",
    height: 120,
    width: 176,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,120)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fill: "#c6011f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 740.23,0 c 366.76,0 576.76,239.262 576.76,456.762 C 1316.99,716.988 1026.76,900 716.25,900 467.27,900 294.77,753.012 200.23,641.25 71.25,487.5 0,468.012 0,468.012 99.7695,380.23 146.988,336.02 193.52,285.738 323.98,144.77 431.988,0 740.23,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 733.52,61.4805 C 467.27,61.4805 362.27,175.512 239.262,306.762 188.98,360.738 156.762,408.75 75,469.488 L 91.4805,430.512 C 170.23,366.02 202.5,319.488 253.52,265.512 377.27,135 480,32.2695 746.25,32.2695 c 233.238,0 413.98,115.4605 498.75,257.2185 l -12.73,30 C 1147.5,176.988 966.762,61.4805 733.52,61.4805"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 740.23,728.238 c -260.23,0 -362.218,-172.5 -362.218,-255.738 0,-48.012 14.258,-90 37.5,-126.02 -15.742,29.258 -19.492,73.52 -19.492,102.04 0,83.242 98.242,249.718 353.242,249.718 153.008,0 268.468,-70.508 307.498,-131.988 h 192.73 c -3.75,6.762 -11.99,30 -11.99,30 h -184.49 c -38.24,61.48 -159.772,131.988 -312.78,131.988"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 239.262,306.762 C 362.27,175.512 467.27,61.4805 733.52,61.4805 c 233.242,0 413.98,115.5075 498.75,257.2695 H 1050 C 964.488,254.262 860.23,201.762 727.5,201.762 c -122.27,0 -250.512,50.968 -311.988,144.718 -24.032,36.02 -37.5,78.008 -37.5,126.02 0,83.238 101.988,255.738 363.008,255.738 152.96,0 274.49,-70.508 312.73,-131.988 H 1237.5 C 1151.99,765 931.48,866.25 711.02,866.25 494.262,866.25 329.262,741.02 233.98,628.52 108.012,480 75,469.488 75,469.488 156.762,408.75 188.98,360.738 239.262,306.762"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 848.98,489.77 h -41.25 v 19.492 h -60.742 v -39.774 h 20.282 v 19.492 h 39.718 l 21.024,-19.492 h 41.25 v 54.032 l -20.282,20.23 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 678.75,361.48 19.488,-20.23 h 171.024 v 53.238 L 848.98,414.77 v -53.29 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 746.988,435 v -39.77 h 20.282 v 19.54 h 50.23 v 34.492 l -20.23,20.226 V 435 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 678.75,509.262 19.488,-20.282 h 7.5 v 20.282 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 444.77,509.262 465,488.98 h 6.762 v 20.282 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 444.77,361.48 465,341.25 h 95.23 V 375 L 540,395.23 v -33.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 591.02,443.98 21.71,-48.75 h 11.25 l -12.73,28.52 30.738,25.512 v 39.718 l -20.226,20.282 v -39.774 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 513.012,435 v -39.77 h 20.226 v 20.282 H 560.23 L 551.25,435 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 635.23,361.48 h -51.71 l 19.492,-20.23 h 52.5 V 375 l -20.282,20.23 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 580.512,488.98 v 11.25 L 570,509.262 H 513.012 V 468.75 h 20.226 v 20.23 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 746.988,509.262 H 807.73 V 489.77 h 41.25 v 53.98 H 678.75 v -34.488 h 26.988 V 395.23 H 678.75 v -33.75 h 170.23 v 53.29 H 807.73 V 395.23 H 746.988 V 435 h 50.282 v 34.488 h -50.282 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 635.23,395.23 h -22.5 l -20.968,49.54 30,24.718 v 39.774 l -41.25,34.488 H 444.77 v -34.488 h 26.992 V 395.23 H 444.77 V 361.48 H 540 v 33.75 H 512.27 V 435 h 38.98 l 8.98,-20.23 23.29,-54.032 h 51.71 z m -101.992,73.52 h -20.226 v 39.77 H 570 l 10.512,-9.032 V 476.25 l -9.774,-8.238 h -37.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 892.5,509.262 19.488,-20.282 h 7.5 v 20.282 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1021.48,488.98 v 11.25 l -10.46,9.032 H 960 V 395.23 h 20.23 v 93.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1061.99,395.23 -40.51,-33.75 H 892.5 l 19.488,-20.23 h 116.252 l 54.03,44.262 V 488.98 l -20.28,20.282 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1196.99,435 h -51.76 l -40.46,34.488 64.49,-54.718 h 38.24 v 11.25 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 1268.24,414.77 1248.01,435 v -38.98 l -40.51,-35.282 h -51.76 l -10.51,9.774 v -9.774 h -40.46 l 19.49,-20.226 h 41.25 v 9.718 l 10.51,-8.98 h 39.72 l 52.5,43.52 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1207.5,489.77 v 10.46 l -10.51,9.032 h -40.51 l -10.46,-9.032 v -22.5 l 10.46,-8.242 h 9.77 V 480 l 10.51,8.98 h 30 l 20.97,-19.492 h 40.51 v 54.032 l -20.23,20.23 v -53.98 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1155,395.23 h 11.25 l -21.02,19.54 v -11.25 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1061.99,395.23 v 114.032 l -41.25,34.488 H 892.5 v -34.488 h 26.988 V 395.23 H 892.5 v -33.75 h 128.98 z m -81.76,0 H 960 v 114.032 h 51.02 l 10.46,-9.032 v -96.71 l -9.72,-8.29 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1145.23,370.512 10.51,-9.774 h 51.76 l 40.51,35.282 V 435 l -41.25,34.488 h -50.28 l -10.46,8.242 v 22.5 l 10.46,9.032 h 40.51 l 10.51,-9.032 v -10.46 h 40.51 v 53.98 h -40.51 v -8.98 l -10.51,8.98 h -50.97 l -41.25,-34.488 V 469.488 L 1145.23,435 h 51.76 l 10.51,-8.98 v -22.5 l -9.77,-8.29 H 1155 l -9.77,8.29 v 11.25 h -40.46 v -54.032 h 40.46 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1207.5,120 h -12.73 V 84.7695 h -9.03 V 120 h -12.73 v 7.5 h 35.23 V 120 Z m 59.26,-36.0195 h -9.03 V 118.52 L 1245,83.9805 h -8.24 L 1224.77,118.52 V 83.9805 h -9.03 V 127.5 h 15 l 9.77,-28.5195 10.51,28.5195 h 15 V 83.9805 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCincinnatiRedsLogo);
export default __webpack_public_path__ + "static/media/cincinnati-reds-logo.dd68c245f2454038c84c2eeb2550869e.svg";
export { ForwardRef as ReactComponent };